<template>
  <v-container class="pa-0">
    <MessagePopup :text="errorMessage" color="error"/>
    <v-row>
      <v-col cols="12" class='text-center pa-0'>
        <v-row>
          <v-col cols="2" v-if="page > 1">
            <v-btn icon small outlined @click="page--" :aria-disabled="page <= 1">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="2" v-else>
            <v-btn small icon outlined @click="refreshData">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-progress-circular indeterminate size="25" width="2" v-if="loading"></v-progress-circular>
            <span v-else-if="totalItems === 0">No update available</span>
            <span v-else>{{ createdAtFromNow }} ({{ page.toLocaleString() }}/{{ totalItems.toLocaleString() }})</span>
          </v-col>
          <v-col cols="2">
            <v-btn icon small outlined @click="page++" :disabled="page >= totalItems">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row v-if="!loading && totalItems > 0">
      <v-col cols="12" sm="6">
        <v-simple-table>
          <template v-slot:default>
            <tbody>
              <tr><th colspan="2">Procurement details</th></tr>
              <tr>
                <td>Stock</td>
                <td v-if="item.stock > 0">{{ item.stock.toLocaleString() }}</td>
                <td v-else>Nothing</td>
              </tr>
              <tr>
                <td>Leadtime</td>
                <td v-if="item.leadTime > 0">{{ (item.leadTime / 7).toLocaleString(undefined, { maximumFractionDigits: 0 }) }} weeks</td>
                <td v-else>Unknown</td>
              </tr>
              <tr v-if="item.minimumOrderQuantity !== item.minimumPackageQuantity"><td>MOQ</td><td>{{ item.minimumOrderQuantity.toLocaleString() }}</td></tr>
              <tr v-else><td>MOQ (MPQ)</td><td>{{ item.minimumOrderQuantity.toLocaleString() }} ({{ item.minimumPackageQuantity.toLocaleString() }})</td></tr>
              <tr v-if="item.additionnalFee > 0"><td>Extra fee</td><td>{{ item.additionnalFee.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2, currency: item.currency, currencyDisplay: 'symbol', style: 'currency' }) }}</td></tr>
              <tr><td>Prices graph</td><td>
                <v-dialog max-width="480px">
                  <template v-slot:activator="{ on }">
                    <v-btn x-small outlined v-on="on">Open</v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="headline">Price evolution versus quantity</v-card-title>
                    <v-card-text><ChartArticlePrices :prices="item.prices"/></v-card-text>
                  </v-card>
                </v-dialog>
              </td></tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
      <v-col cols="12" sm="6">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr><th>Quantity</th><th>Unit price</th></tr>
            </thead>
            <tbody>
              <tr v-for="(price, key) in item.prices" :key="key">
                <td>{{ price.quantity.toLocaleString() }}</td>
                <td>{{ price.price.toLocaleString(undefined, { minimumFractionDigits: 4, maximumFractionDigits: 4, currency: item.currency, currencyDisplay: 'symbol', style: 'currency' }) }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from 'moment'
import MessagePopup from '@/components/MessagePopup.vue'
import ChartArticlePrices from '@/components/ChartArticlePrices'

export default {
  props: ['target'],
  data: () => ({
    item: {},
    totalItems: 0,
    page: 1,
    loading: true,
    errorMessage: ''
  }),
  components: {
    MessagePopup,
    ChartArticlePrices
  },
  computed: {
    createdAtFromNow () {
      if (this.item.createdAt) {
        return moment(this.item.createdAt).fromNow()
      }
      return ''
    }
  },
  watch: {
    page () {
      this.getData()
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.errorMessage = ''
      this.$http(this.target + '/updates', {
        params: {
          page: this.page,
          itemsPerPage: 1,
          order: {
            createdAt: 'desc'
          }
        }
      })
        .then(response => {
          this.totalItems = response.data['hydra:totalItems']
          this.item = response.data['hydra:member'].length === 1 ? response.data['hydra:member'][0] : {}
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    refreshData () {
      this.loading = true
      this.errorMessage = ''
      this.$http(this.target + '/refresh')
        .then(() => {
          if (this.page !== 1) {
            this.page = 1
          } else {
            this.getData()
          }
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data['hydra:description'].replace(/\n/g, '<br/>')
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
